import React from 'react';
import { Card, CardContent, CardFooter, CardHeader } from '../ui/Card';
import { Button } from '../ui/Button';
import { ShieldCheck, FileText, ArrowRight } from 'lucide-react';
interface ConsentFormProps {
  onAccept: () => void;
}
export function ConsentForm({
  onAccept
}: ConsentFormProps) {
  return <Card className="max-w-2xl mx-auto border-t-4 border-t-blue-900" data-id="element-1">
      <CardHeader data-id="element-2">
        <div className="flex items-center gap-3 mb-2" data-id="element-3">
          <div className="p-2 bg-blue-100 rounded-lg" data-id="element-4">
            <FileText className="w-6 h-6 text-blue-900" data-id="element-5" />
          </div>
          <h2 className="text-2xl font-bold text-slate-900" data-id="element-6">
            Diagnóstico de Maturidade em PI
          </h2>
        </div>
        <p className="text-slate-600" data-id="element-7">
          Ferramenta de diagnóstico para Micro, Pequenas e Médias Empresas
          (MPMEs) da região de Santarém/Oeste do Pará.
        </p>
      </CardHeader>

      <CardContent className="space-y-6" data-id="element-8">
        <div className="bg-slate-50 p-6 rounded-lg border border-slate-200" data-id="element-9">
          <h3 className="flex items-center text-lg font-semibold text-slate-900 mb-3" data-id="element-10">
            <ShieldCheck className="w-5 h-5 text-teal-600 mr-2" data-id="element-11" />
            Termo de Consentimento (LGPD)
          </h3>
          <p className="text-slate-700 leading-relaxed mb-4" data-id="element-12">
            Em conformidade com a Lei Geral de Proteção de Dados (LGPD),
            informamos que:
          </p>
          <ul className="list-disc list-inside space-y-2 text-slate-700 ml-2" data-id="element-13">
            <li data-id="element-14">
              Os dados individuais serão mantidos em{' '}
              <strong data-id="element-15">sigilo absoluto</strong>.
            </li>
            <li data-id="element-16">
              Apenas dados agregados (estatísticas) serão utilizados na pesquisa
              acadêmica do Mestrado Profissional (PROFNIT).
            </li>
            <li data-id="element-17">
              Sua participação é voluntária e você pode desistir a qualquer
              momento.
            </li>
            <li data-id="element-18">
              Ao final, você receberá um{' '}
              <strong data-id="element-19">relatório automático gratuito</strong> com recomendações
              personalizadas.
            </li>
          </ul>
        </div>

        <div className="text-sm text-slate-500" data-id="element-20">
          Tempo estimado: 3-5 minutos
        </div>
      </CardContent>

      <CardFooter className="flex justify-end" data-id="element-21">
        <Button onClick={onAccept} size="lg" className="w-full sm:w-auto" data-id="element-22">
          Concordo e Quero Iniciar
          <ArrowRight className="ml-2 w-5 h-5" data-id="element-23" />
        </Button>
      </CardFooter>
    </Card>;
}